import { render, staticRenderFns } from "./SalSearch.vue?vue&type=template&id=c59a687a&scoped=true&"
import script from "./SalSearch.vue?vue&type=script&lang=js&"
export * from "./SalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59a687a",
  null
  
)

export default component.exports